import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { CvIssueConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { CvIssueService } from './api/cvIssue.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class CvIssueApiModule {
    public static forRoot(configurationFactory: () => CvIssueConfiguration): ModuleWithProviders<CvIssueApiModule> {
        return {
            ngModule: CvIssueApiModule,
            providers: [ { provide: CvIssueConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: CvIssueApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('CvIssueApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
